import { useCallback } from 'react';

import { APP_PRODUCT_TYPE } from 'appConstants';
import { useProducts } from 'contexts/Products';
import ProductSelectField from 'fields/ProductSelectField';
import { useField } from 'formik';

import type { IProductName } from './types';

export default function ProductName({ disabled }: IProductName) {
  const [, , { setValue }] = useField('productData');
  const [, , { setValue: setPackagedItemQty }] = useField('packagedItemQty');
  const [, , { setValue: setQuantity }] = useField('quantity');

  const {
    state,
    selectors: { selectProduct },
  } = useProducts();

  const handleChange = useCallback(
    (value) => {
      setValue(selectProduct(state, value) || {});
      setPackagedItemQty('');
      setQuantity('');
    },
    [setPackagedItemQty, selectProduct, setQuantity, setValue, state],
  );

  return (
    <ProductSelectField
      name="packagedItemReference"
      disabled={disabled}
      onChange={handleChange}
      productType={APP_PRODUCT_TYPE.CROP}
      textFieldProps={{
        required: true,
      }}
    />
  );
}
